import * as React from 'react';
import "./vyberservisupage.scss";
import {FilterProvider} from "../../context/FilterProvider";
import VyberServisuPageContent from "./VyberServisuPageContent";
import ModalRoot from "../../components/modal/ModalRoot";
import { MapContext } from "../../context/MapContext";
import {useState} from "react";
import {FilterOverlayContext} from "../../context/FilterOverlayContext";
import OverlayFilter from "../../components/MapaServisu/OverlayFilter";


const VyberServisuPage = () => {
    const [centeredService, setCenteredService] = useState(null);
    const [isMapServicesOpened, setIsMapServicesOpened] = useState(true);
    const [isOverlayFilterOpen, setIsOverlayFilterOpen] = useState(false);
    return (
        <MapContext.Provider value={{ centeredService, setCenteredService, isMapServicesOpened, setIsMapServicesOpened }}>
            <FilterProvider>
                <FilterOverlayContext.Provider value={{ isOverlayFilterOpen, setIsOverlayFilterOpen }}>
                    {isOverlayFilterOpen &&  <OverlayFilter />}
                    <ModalRoot />
                    <VyberServisuPageContent/>
                </FilterOverlayContext.Provider>
            </FilterProvider>
        </MapContext.Provider>
    )
}
export default VyberServisuPage;